import { create } from 'zustand';
import { ApiUtils, FileApi, type StoreBaseReturn } from '@shared/api';

interface UseDeleteFileStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  deleteFile: (fileId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useDeleteFileStore = create<UseDeleteFileStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  deleteFile: async (fileId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await FileApi.deleteFile(fileId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
